import React from 'react';
import PropTypes from 'prop-types';
import {View} from 'react-native';

const activeTrackColor = '#2907E3';
const disabledTrackColor = '#F2F2F2';

const activeThumbColor = '#FAFAFA';
const disabledThumbColor = '#79747E';

const Switch = (props) => {
  const {
    'aria-label': ariaLabel,
    accessibilityLabel,
    disabled = false,
    onValueChange,
    style = {},
    value = false,
    ...other
  } = props;

  const thumbRef = React.useRef(null);

  function handleChange(event) {
    if (onValueChange != null) {
      onValueChange(event.nativeEvent.target.checked);
    }
  }

  const rootStyle = [styles.root, style, disabled && styles.rootDisabled];

  const trackStyle = [
    styles.track,
    {
      backgroundColor: value ? activeTrackColor : disabledTrackColor,
      borderColor: value ? activeTrackColor : disabledThumbColor,
    },
  ];

  const thumbStyle = [
    styles.thumb,
    value && styles.thumbActive,
    {
      backgroundColor: value ? activeThumbColor : disabledThumbColor,
      borderColor: value ? activeThumbColor : disabledTrackColor,
      marginStart: value ? '-24px' : '0px',
    },
  ];

  return (
    <View {...other} style={rootStyle}>
      <View style={trackStyle} />
      <View ref={thumbRef} style={thumbStyle} />
      <input
        aria-label={ariaLabel || accessibilityLabel}
        checked={value}
        disabled={disabled}
        onChange={handleChange}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          height: '100%',
          margin: 0,
          appearance: 'none',
          padding: 0,
          width: '100%',
          cursor: 'inherit',
        }}
        type="checkbox"
        role="switch"
      />
    </View>
  );
};
Switch.propTypes = {};

const styles = {
  root: {
    cursor: 'pointer',
    userSelect: 'none',
    height: '32px',
    width: '52px',
    padding: '4px',
  },
  rootDisabled: {
    opacity: 0.5,
    cursor: 'default',
  },
  track: {
    forcedColorAdjust: 'none',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '100%',
    margin: 'auto',
    width: '100%',
    borderRadius: '100px',
    border: 'solid 2px black',
  },
  thumb: {
    forcedColorAdjust: 'none',
    alignSelf: 'flex-start',
    borderRadius: '100%',
    start: '0%',
    transform: 'translateZ(0)',
    transitionDuration: '0.1s',
    height: '24px',
    width: '24px',
    border: '4px solid',
  },
  thumbActive: {
    insetInlineStart: '100%',
  },
};

Switch.propTypes = {
  'aria-label': PropTypes.string,
  accessibilityLabel: PropTypes.string,
  disabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.bool,
};

export default Switch;
